<template>
  <div id="app" class="min-h-screen flex">
    <Edit/>
    <Canvas/>
    <div class="absolute bottom-2 right-2 flex -space-x-1 overflow-hidden text-xxs">
      <div class="mr-4 text-gray-400">Releasing new plugin every 30 days, say hi 👉</div>
      <a href="https://twitter.com/klautobuss" target="_blank"><img class="inline-block h-6 w-6 rounded-full ring-2 ring-white" src="https://pbs.twimg.com/profile_images/946110276503506944/Uy2SJoj4_400x400.jpg" alt="" /></a>
      <a href="https://twitter.com/zarembaaaa" target="_blank"><img class="inline-block h-6 w-6 rounded-full ring-2 ring-white" src="https://pbs.twimg.com/profile_images/1274400728879071234/3gkQNK2S_400x400.jpg" alt="" /></a>
    </div>
    <!-- <CanvasExperiment/> -->
  </div>
</template>

<script>

import Canvas from "@/components/Canvas";
import Edit from "@/components/Edit";
import CanvasExperiment from "@/components/experiments/CanvasExperiment5";

export default {
  name: "App",
  components: {
    Canvas,
    Edit,
    CanvasExperiment,
  },
};
</script>
<style scoped>
</style>
